import { Button } from 'flowbite-react';
import React from 'react';
import { HiOutlineStar, HiStar } from 'react-icons/hi';
import { PositionCandidatesTabsEnum } from '../freshersPosition/PositionCandidateListingTabs';
import { CampusUserWithApplication } from 'types';
import { CandidatesTabsEnum } from 'src/components/recruiterPositions/RecruiterCandidatesContainer2';
import { shortlistDriveCandidate } from 'src/apis/drive';
import { useMutation, useQueryClient } from 'react-query';
import { useToast } from 'src/context/ToastProvider';
import { useParams } from 'react-router-dom';
import { get } from 'lodash';

const DriveCandidatesActionButton = ({
	selectedTab,
	studentData,
}: {
	selectedTab?: PositionCandidatesTabsEnum | CandidatesTabsEnum;
	studentData: CampusUserWithApplication;
}) => {
	const toast = useToast();
	const { id } = useParams();
	const queryClient = useQueryClient();
	const shortlistUserFn = useMutation(['shortlistDriveCandidate'], shortlistDriveCandidate, {
		onSuccess(data) {
			queryClient.refetchQueries({
				queryKey: ['getDriveCandidates'],
				exact: false,
			});
			queryClient.refetchQueries({
				queryKey: ['getDrivePositionApplicants'],
				exact: false,
			});
			toast({
				title: 'Candidate shortlisted successfully',
				type: 'success',
			});
		},
		onError(error: Error) {
			const errorMessage = get(error, ['response', 'data', 'message'], error.message);
			toast({
				title: `Error occured ${errorMessage}`,
				type: 'error',
			});
		},
	});

	return (
		<div className="flex justify-end md:justify-center">
			{studentData?.application ? (
				<Button color="purplePlaced" className="[&_span]:!p-0 !px-[16px] !py-[8px] border-[#E5E7EB]">
					<HiStar className="h-[16px] w-[16px] mr-[8px] text-[#FFFFFF]" />
					Shortlisted
				</Button>
			) : (
				<Button
					color="light"
					disabled={shortlistUserFn?.isLoading}
					isProcessing={shortlistUserFn?.isLoading}
					onClick={() => {
						shortlistUserFn.mutate({ userId: studentData._id, positionId: id ?? '' });
					}}
					className="[&_span]:!p-0 !px-[16px] !py-[8px] bg-[#FAFAFC] border-[#7777E7] text-[#7777E7]"
				>
					<HiOutlineStar className="mr-[8px]" />
					Shortlist
				</Button>
			)}
		</div>
	);
};

export default DriveCandidatesActionButton;
